import { get, isArray, map, replace, toString, trim } from 'lodash';
import {
  AnalyticsArticle,
  AnalyticsArticleTag,
} from '../../interfaces/analyticsArticle';

/*
 * Private helper functions
 */

const buildTitle = (title: string) => replace(trim(title), /\s+/g, ' ');

const buildTags = (tags: AnalyticsArticleTag[]) =>
  isArray(tags) ? map(tags, 'name').join(',') : toString(get(tags, 'name', ''));

const build = (article = {} as AnalyticsArticle) => {
  const { id, title, tags, articleTypeInGA } = article;

  return {
    article: {
      id: toString(id),
      title: buildTitle(title),
      type: articleTypeInGA,
      section: '',
      tags: buildTags(tags),
      subsection: '',
    },
  };
};

export default {
  build,
};
